import React, { memo } from 'react';
import { StyleSheet, useWindowDimensions, View, } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconTokens, PartnerBenefitCardType, } from '@voltmoney/schema';
import { Typography } from '../typography/Typography';
import { Icon } from '../icon/Icon';
/**
 * Primary UI component for user interaction
 */
const data = [
    {
        id: 1,
        title: 'Register client',
        subTitle: 'Help your clients retain their investments',
    },
    {
        id: 2,
        title: 'Track clients & earnings',
        subTitle: 'Track your client activities easily anytime',
    },
    {
        id: 3,
        title: 'Access co-branded collaterals',
        subTitle: 'Create your unique brand identity with us',
    },
];
const PartnerbenefitCard = ({ showCard, type = PartnerBenefitCardType.DEFAULT, data }) => {
    const { width } = useWindowDimensions();
    const BreakPoints = {
        WEB: 1024,
    };
    let theme = ThemeProvider.getTheme();
    let colorMapping = theme.colors;
    let borderRadiusMapping = theme.borderRadius;
    let fontMapping = theme.fontFamily;
    let fontSizeMapping = theme.fontSize;
    const styles = StyleSheet.create({
        benefitsContainer: {
            width: '100%',
        },
        benefitsItemContainer: {
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center',
        },
        benefitsIconContainer: {
            backgroundColor: colorMapping[ColorTokens.Primary_05],
            borderRadius: 20,
            height: 32,
            width: 32,
            justifyContent: 'center',
            alignItems: 'center',
        },
    });
    const _default = () => {
        return (React.createElement(View, { style: styles.benefitsContainer },
            React.createElement(Typography, { label: 'Get instant cash / overdraft against mutual funds', fontFamily: FontFamilyTokens.Inter, fontSize: width < BreakPoints.WEB
                    ? FontSizeTokens.MD
                    : FontSizeTokens.LG, lineHeight: width < BreakPoints.WEB ? 24 : 26, fontWeight: '400', color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: {
                    height: width < BreakPoints.WEB ? 16 : 28,
                } }),
            React.createElement(View, { style: styles.benefitsItemContainer },
                React.createElement(View, { style: styles.benefitsIconContainer },
                    React.createElement(Icon, { name: IconTokens.Secure })),
                React.createElement(View, { style: { width: 16 } }),
                React.createElement(Typography, { label: 'Borrow from trusted Banks/NBFCs', fontFamily: FontFamilyTokens.Inter, fontSize: width < BreakPoints.WEB
                        ? FontSizeTokens.SM
                        : FontSizeTokens.MD, lineHeight: 24, fontWeight: '400', color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: {
                    height: width < BreakPoints.WEB ? 16 : 28,
                } }),
            React.createElement(View, { style: styles.benefitsItemContainer },
                React.createElement(View, { style: styles.benefitsIconContainer },
                    React.createElement(Icon, { name: IconTokens.ThumpsUp })),
                React.createElement(View, { style: { width: 16 } }),
                React.createElement(Typography, { label: `Interest rates start at 9%`, fontFamily: FontFamilyTokens.Inter, fontSize: width < BreakPoints.WEB
                        ? FontSizeTokens.SM
                        : FontSizeTokens.MD, lineHeight: 24, fontWeight: '400', color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: {
                    height: width < BreakPoints.WEB ? 16 : 28,
                } }),
            React.createElement(View, { style: styles.benefitsItemContainer },
                React.createElement(View, { style: styles.benefitsIconContainer },
                    React.createElement(Icon, { name: IconTokens.Clock })),
                React.createElement(View, { style: { width: 16 } }),
                React.createElement(Typography, { label: '5 minute digital process', fontFamily: FontFamilyTokens.Inter, fontSize: width < BreakPoints.WEB
                        ? FontSizeTokens.SM
                        : FontSizeTokens.MD, lineHeight: 24, fontWeight: '400', color: ColorTokens.Grey_Night }))));
    };
    const _success_empanel = () => {
        return (React.createElement(View, null, data && data.map((item, index) => (React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'row',
                paddingBottom: 24
            } },
            React.createElement(View, { style: {
                    backgroundColor: colorMapping[ColorTokens.Grey_Milk_1],
                    borderRadius: 50,
                    width: 32,
                    height: 32,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingVertical: 7,
                    paddingHorizontal: 12,
                    marginRight: 12
                } }, index + 1),
            React.createElement(View, null,
                React.createElement(Typography, { label: `${item.title}`, fontWeight: '500', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, lineHeight: 20 }),
                React.createElement(View, { style: {
                        height: 8
                    } }),
                React.createElement(Typography, { label: `${item.subTitle}`, fontWeight: '400', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal, lineHeight: 20 })))))));
    };
    const _affiliate = () => {
        return (React.createElement(View, { style: styles.benefitsContainer },
            React.createElement(Typography, { label: 'Get Instant cash/ Overdraft against mutual funds within same day', fontFamily: FontFamilyTokens.Inter, fontSize: width < BreakPoints.WEB
                    ? FontSizeTokens.MD
                    : FontSizeTokens.LG, lineHeight: width < BreakPoints.WEB ? 24 : 26, fontWeight: '400', color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: {
                    height: width < BreakPoints.WEB ? 16 : 28,
                } }),
            React.createElement(View, { style: styles.benefitsItemContainer },
                React.createElement(View, { style: styles.benefitsIconContainer },
                    React.createElement(Icon, { name: IconTokens.Secure })),
                React.createElement(View, { style: { width: 16 } }),
                React.createElement(Typography, { label: 'Earn commission from each successful credit loan disbursed', fontFamily: FontFamilyTokens.Inter, fontSize: width < BreakPoints.WEB
                        ? FontSizeTokens.SM
                        : FontSizeTokens.MD, lineHeight: 24, fontWeight: '400', color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: {
                    height: width < BreakPoints.WEB ? 16 : 28,
                } }),
            React.createElement(View, { style: styles.benefitsItemContainer },
                React.createElement(View, { style: styles.benefitsIconContainer },
                    React.createElement(Icon, { name: IconTokens.ThumpsUp })),
                React.createElement(View, { style: { width: 16 } }),
                React.createElement(Typography, { label: 'Clients borrow from trusted Banks/NBFCs', fontFamily: FontFamilyTokens.Inter, fontSize: width < BreakPoints.WEB
                        ? FontSizeTokens.SM
                        : FontSizeTokens.MD, lineHeight: 24, fontWeight: '400', color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: {
                    height: width < BreakPoints.WEB ? 16 : 28,
                } }),
            React.createElement(View, { style: styles.benefitsItemContainer },
                React.createElement(View, { style: styles.benefitsIconContainer },
                    React.createElement(Icon, { name: IconTokens.Percentage })),
                React.createElement(View, { style: { width: 16 } }),
                React.createElement(Typography, { label: `Interest rates between 10.49% to 10.99%`, fontFamily: FontFamilyTokens.Inter, fontSize: width < BreakPoints.WEB
                        ? FontSizeTokens.SM
                        : FontSizeTokens.MD, lineHeight: 24, fontWeight: '400', color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: {
                    height: width < BreakPoints.WEB ? 16 : 28,
                } }),
            React.createElement(View, { style: styles.benefitsItemContainer },
                React.createElement(View, { style: styles.benefitsIconContainer },
                    React.createElement(Icon, { name: IconTokens.Clock })),
                React.createElement(View, { style: { width: 16 } }),
                React.createElement(Typography, { label: '5 minute digital process', fontFamily: FontFamilyTokens.Inter, fontSize: width < BreakPoints.WEB
                        ? FontSizeTokens.SM
                        : FontSizeTokens.MD, lineHeight: 24, fontWeight: '400', color: ColorTokens.Grey_Night }))));
    };
    switch (type) {
        case PartnerBenefitCardType.AFFILIATE:
            return _affiliate();
        case PartnerBenefitCardType.SUCCESS_EMPANEL:
            return _success_empanel();
        case PartnerBenefitCardType.DEFAULT:
            return _default();
    }
    // return type ===
    // 	PartnerBenefitCardType.DEFAULT ? (
    // 	<>{_default()}</>
    // ) : (
    // 	<>{_success_empanel()}</>
    // );
    return React.createElement(React.Fragment, null, _default());
};
export default memo(PartnerbenefitCard);
export { PartnerbenefitCard };
